import React from 'react';
import certificate_template from '../../assets/certificates/certificates.jpeg';

const Certificate = ({
  name = "Amar G.",
  credentialId = "PLU-NC-PEVO-987654321",
  issuedDate = "May 24, 2025",
  course = "North Carolina PilotLink Crash Course",
  // Optional: Pass a QR code image URL as a prop to fill the blank box
  qrCodeSrc = "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://pilotlinkusa.org/verify/PLU-NC-PEVO-987654321" 
}) => {
  return (
    <div 
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '1100px', // Standardized enterprise max-width
        margin: '0 auto',
        backgroundColor: '#ffffff',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)', // Premium shadow for web display
        overflow: 'hidden',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif'
      }}
    >
      {/* Background Template */}
      <img
        src={certificate_template}
        alt="Certification of Preparation"
        style={{ width: '100%', display: 'block', height: 'auto' }}
      />

      {/* Recipient Name */}
      <div 
        style={{
          position: 'absolute',
          top: '34%', 
          left: '58.5%', // Centered within the right-side printable area
          transform: 'translateX(-50%)',
          fontSize: '4.2vw', 
          fontFamily: 'Georgia, "Times New Roman", serif', 
          color: '#0d1b2a', 
          textAlign: 'center',
          width: '65%',
          letterSpacing: '0.5px'
        }}
      >
        {name}
      </div>

      {/* Decorative Red Line (Optional: If not baked into the image) */}
      <div 
        style={{
          position: 'absolute',
          top: '44%',
          left: '58.5%',
          transform: 'translateX(-50%)',
          width: '25%',
          height: '2px',
          backgroundColor: '#c1121f', // PilotLinkUSA red
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        {/* Small center diamond on the red line */}
        <div style={{ width: '6px', height: '6px', backgroundColor: '#c1121f', transform: 'rotate(45deg)' }}></div>
      </div>

      {/* Description Paragraph */}
      <div 
        style={{
          position: 'absolute',
          top: '48%', 
          left: '58.5%',
          transform: 'translateX(-50%)',
          fontSize: '1.25vw', 
          color: '#333333', 
          textAlign: 'center',
          width: '52%',
          lineHeight: '1.6'
        }}
      >
        For successfully completing the <b>PilotLinkUSA PPCA Crash Course</b>. 
        This achievement demonstrates the completion of required training and 
        an understanding of applicable laws and regulations, safety procedures, 
        equipment requirements, and best practices for professional pilot car 
        and escort operations.
      </div>

      {/* Credential ID */}
      <div 
        style={{
          position: 'absolute',
          top: '68.5%',
          left: '49.5%', 
          fontSize: '1.3vw',
          color: '#1a1a1a',
          fontWeight: '700'
        }}
      >
        {credentialId}
      </div>

      {/* Issued Date */}
      <div 
        style={{
          position: 'absolute',
          top: '74.5%',
          left: '49.5%',
          fontSize: '1.3vw',
          color: '#1a1a1a',
          fontWeight: '500'
        }}
      >
        {issuedDate}
      </div>

      {/* Course Name */}
      <div 
        style={{
          position: 'absolute',
          top: '80.5%',
          left: '49.5%',
          fontSize: '1.3vw',
          color: '#1a1a1a',
          fontWeight: '500'
        }}
      >
        {course}
      </div>

      {/* QR Code Graphic */}
      {qrCodeSrc && (
        <img 
          src={qrCodeSrc}
          alt="Verification QR Code"
          style={{
            position: 'absolute',
            top: '65.5%', // Aligns inside the empty rounded box
            left: '81.9%',
            width: '9.5%', // Scales perfectly with the certificate
            height: 'auto',
            mixBlendMode: 'multiply' // Ensures it blends cleanly with the background
          }}
        />
      )}
    </div>
  );
};

export default Certificate;